import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {UserStorageService} from '../../../services/user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TurnsDaoService {

  private HEADERS = 'headers';
  private PARAMS = 'params';
  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };
  private options = {};

  constructor(
    private http: HttpClient,
    private userStorageService: UserStorageService
  ) {
  }

  private fillHeaderOptions() {
    this.options = {};
    Object.assign(this.options, this.OPTIONS);
    this.options[this.HEADERS] = this.options[this.HEADERS].append('context', this.userStorageService.getContext());
    this.options[this.HEADERS] = this.options[this.HEADERS].append('lang', this.userStorageService.getLang());
    this.options[this.HEADERS] = this.options[this.HEADERS].append('udid', this.userStorageService.getUDID());
  }

  public getControlDesks() {
    this.fillHeaderOptions();
    return this.http.get(this.BASE_URL +  '/api/v3.0/control/list', this.options);
  }

  public changeDeskStatus(internalId, status) {
    this.fillHeaderOptions();
    const item = { internalId, status };
    return this.http.put(this.BASE_URL +  '/api/v3.0/control/turnDesk/status', item, this.options);
  }

  public pushTurn(deskId) {
    this.fillHeaderOptions();
    const item = { deskId };
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/pushTurn', item, this.options);
  }

  public callNextDeskLocation(internalId) {
    this.fillHeaderOptions();
    const item = { internalId };
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/ws_callNextDeskLocation', item, this.options);
  }

  public callNextDeskLocationTurn(locationInternalId, turnInternalId) {
    this.fillHeaderOptions();
    const item = { locationInternalId, turnInternalId };
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/callNextDeskLocationTurnId', item, this.options);
  }

  public addTurnInformation(body) {
    this.fillHeaderOptions();
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/addTurnInformation', body, this.options);
  }

  public callBackLastTurn(deskId) {
    this.fillHeaderOptions();
    const item = { deskId };
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/callBackLastTurn', item, this.options);
  }

  public callbackLastLocationTurn(internalId) {
    this.fillHeaderOptions();
    const item = { internalId };
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/callBackLastTurnAtLocation', item, this.options);
  }

  public requeueTurn(internalId) {
    this.fillHeaderOptions();
    const item = { internalId };
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/requeueLastTurnAtLocation', item, this.options);
  }

  public transfer(turnInternalId, turnDeskInternalId, locationInternalId, mode) {
    this.fillHeaderOptions();
    const item = { turnInternalId, turnDeskInternalId, locationInternalId, mode };
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/transfer', item, this.options);
  }

  public finishAttendance(turnDeskInternalId, locationInternalId) {
    this.fillHeaderOptions();
    const item = { turnDeskInternalId, locationInternalId };
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/finishAttendance', item, this.options);
  }

  public getCompanyInfo(internalId) {
    this.fillHeaderOptions();
    const item = { internalId };
    return this.http.post(this.BASE_URL + '/api/v2.0/company/ws_getCompanyImages', item, this.options);
  }

  public openDeskLocation(internalId) {
    this.fillHeaderOptions();
    const item = { internalId };
    return this.http.post(this.BASE_URL + '/api/v3.0/control/openDeskLocation', item, this.options);
  }

  public closeDeskLocation(internalId) {
    this.fillHeaderOptions();
    const item = { internalId };
    return this.http.post(this.BASE_URL + '/api/v3.0/control/closeDeskLocation', item, this.options);
  }

  public deskLocationCurrently(internalId) {
    this.fillHeaderOptions();
    this.options[this.PARAMS] = {internalId};
    return this.http.get(this.BASE_URL + '/api/v3.0/control/deskLocationCurrently', this.options);
  }

  public deskCurrently(internalId) {
    this.fillHeaderOptions();
    this.options[this.PARAMS] = {internalId};
    return this.http.get(this.BASE_URL + '/api/v3.0/control/deskCurrently', this.options);
  }

  public getDeskLocations(internalIdList) {
    this.fillHeaderOptions();
    const item = { internalIdList };
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/getDeskLocationList', item, this.options);
  }

  public getTurnsWaiting(internalId, internalIdLocation) {
    this.fillHeaderOptions();
    let item;
    if (internalId) {
      item = { internalId };
    } else if (internalIdLocation) {
      item = { internalIdLocation };
    }
    return this.http.post(this.BASE_URL +  '/api/v3.0/control/turns/waiting', item, this.options);
  }

  public getControlAllDesks() {
    this.fillHeaderOptions();
    return this.http.get(this.BASE_URL +  '/api/v3.0/control/desk/all', this.options);
  }

  public callNextDueToAbsence(internalId) {
    this.fillHeaderOptions();
    const item = { internalId };
    return this.http.post(this.BASE_URL + '/api/v3.0/control/callNextDueToAbsence', item, this.options);
  }

  public pushTurnDueToAbsence(deskId) {
    this.fillHeaderOptions();
    const item = { deskId };
    return this.http.post(this.BASE_URL + '/api/v3.0/control/pushTurnDueToAbsence', item, this.options);
  }

  public attendWithoutTurn(turnDeskInternalId, locationInternalId) {
    this.fillHeaderOptions();
    const item = { turnDeskInternalId, locationInternalId };
    return this.http.post(this.BASE_URL + '/api/v3.0/control/attendWithoutTurn', item, this.options);
  }

}
